define('shared/page/eTag',[
    '$',
    'shared/initializer/form/constants',
    'shared/util/state', 
    'shared/lib/RSVP',
    'shared/util/dispatchers/DataDispatcher'
], function (
    $,
    constants, 
    state, 
    RSVP, 
    DataDispatcher
) {
    var url = location.pathname;

    return function() {
        var etagSources;
        // as described in SAND-1607 and talked with Martin,
        // /lp/ is considered a keyword and should only be used by landing page
        if (url.indexOf('/lp/') >= 0) {
            etagSources = 
            [{
                type: 'state',
                key: 'page.etag',
                doNotWait: true
            },
            {
                type: 'state',
                key: 'session.etag',
                allowUndefined: true
            }];
        }
        else {
            etagSources = 
            [{
                type: 'state',
                key: 'session.etag',
                allowUndefined: true
            }];
        }

        return RSVP.resolve()
            .then(function(){
                return new RSVP.Promise(function(rs, rj){
                    var value;
                    var dispatcher = new DataDispatcher($('html'));
                    dispatcher.dispatch(
                    {
                        items: 
                        {
                            'session.etag':
                            {
                                sources: etagSources,
                                targets:
                                [{
                                    publish: function(key, v) {
                                        value = v;
                                        return RSVP.resolve();
                                    }
                                }]
                            }
                        },
                        timeout: 1 * 1000
                    })
                    .then(function(){
                        rs(value);
                    }, function(err){
                        rj(err);
                    });
                });
            });
    };
});
